import React from "react";
import { Typography, Box } from "@mui/material";

const HeaderValueDisplay = ({ header, value }) => (
  <Box mb={2}>
    <Typography fontSize="16px" color="primary" >
      {header}
    </Typography>
    <Typography variant="body1">
      {value}
    </Typography>
  </Box>
);

export default HeaderValueDisplay;